var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdRevert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "pd-revert_svg__lucide pd-revert_svg__lucide-rotate-ccw pd-revert_svg__w-4 pd-revert_svg__h-4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v5h5"
  })));
}

export default SvgPdRevert;